import $ from 'jquery';

const filterButton = $('.toggle-filters');
const filterSidebar = $('.FilterSidebar');
const closeFilterBarButton = $('.FilterSidebar__close');

export const handleOpenFilterSidebar = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    filterSidebar.addClass('active');
    $('#main-content').addClass('blured');
};

const handleCloseFilterSidebar = (ev) => {
    ev.preventDefault();
    filterSidebar.removeClass('active');
    $('#main-content').removeClass('blured');
};

$(document).on('click', '#main-content.blured', handleCloseFilterSidebar);

filterButton.on('click', handleOpenFilterSidebar);

closeFilterBarButton.on('click', handleCloseFilterSidebar);

$(window).on('load', () => {
    $('.FilterSidebar').addClass('ready');
});

document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('#filter-form');
    form?.addEventListener('reset', function (e) {
        e.preventDefault();
        form.querySelectorAll('input[type="checkbox"]').forEach(function (chk) {
            chk.checked = false;
        });
        form.querySelectorAll('input[type="number"]').forEach(function (input) {
            input.value = '';
        });
        form.querySelectorAll('input[type="text"]').forEach(function (input) {
            input.value = '';
        });
    });
});

document.querySelectorAll('.show-more-button')?.forEach((btn) => {
    const container = btn.closest('.Filter');
    const content = container.querySelector('.Filter__content');
    const collapsedHeight = 181;

    if (content.scrollHeight <= collapsedHeight) {
        btn.style.display = 'none';
        return;
    }

    content.style.maxHeight = `${collapsedHeight}px`;
    btn.textContent = 'Zobacz więcej';

    btn.addEventListener('click', () => {
        if (content.classList.contains('expanded')) {
            content.style.maxHeight = `${collapsedHeight}px`;
            content.classList.remove('expanded');
            btn.textContent = 'Zobacz więcej';
        } else {
            content.style.maxHeight = `${content.scrollHeight}px`;
            content.classList.add('expanded');
            btn.textContent = 'Zobacz mniej';
        }
    });
});

function renderFilterBadgesFromURL() {
    const container = document.querySelector('#selected-filters');
    if (!container) return;

    const params = new URLSearchParams(window.location.search);
    container.innerHTML = '';

    const entries = Array.from(params.entries()).filter(([key]) => !key.startsWith('utm_'));
    const grouped = {};

    entries.forEach(([key, val]) => {
        const cleanKey = key.replace(/\[\]$/, '');
        if (!grouped[cleanKey]) grouped[cleanKey] = [];
        grouped[cleanKey].push({ key, val });
    });

    if (entries.filter((val) => !!val?.[1]).length) {
        document.querySelector('#selected-filters-title').innerHTML = 'Zaznaczone filtry:';
    } else {
        document.querySelector('#selected-filters-title').innerHTML = '';
    }

    for (const [cleanKey, values] of Object.entries(grouped)) {
        values.forEach(({ key, val }) => {
            if (!val) return;
            const badge = document.createElement('div');
            badge.setAttribute('data-key', key);
            badge.setAttribute('data-value', val);
            badge.className =
                'px-2 bg-primary text-white font-bold text-sm rounded-full flex items-center gap-1 remove-filter';
            badge.innerHTML = `
                <span class="text-[12px]">${formatFilterLabel(cleanKey, val)}</span>
                <button type="button" class="Button--no-style">×</button>
            `;
            container.appendChild(badge);
        });
    }
}

function formatFilterLabel(key, val) {
    if (key === 'pa_kolor') return `Kolor: ${val}`;
    if (key === 'pa_rozmiar') return `Rozmiar: ${val}`;
    if (key === 'price_min') return `Cena od: ${val} zł`;
    if (key === 'price_max') return `Cena do: ${val} zł`;
    return `${key}: ${val}`;
}

function removeFilterFromURL(key, value) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    const remaining = params.getAll(key).filter((v) => v !== value);
    params.delete(key);
    remaining.forEach((v) => params.append(key, v));

    const newUrl = url.pathname + (params.toString() ? `?${params.toString()}` : '');
    history.replaceState(null, '', newUrl);

    const form = document.querySelector('#filter-form');
    if (!form) return;

    form.querySelectorAll(
        `input[type="checkbox"][name="${key}"], input[type="checkbox"][name="${key}[]"]`,
    ).forEach((input) => {
        if (input.value === value) {
            input.checked = false;
        }
    });

    form.querySelectorAll(
        `input[type="text"][name="${key}"], input[type="number"][name="${key}"]`,
    ).forEach((input) => {
        if (input.value === value) {
            input.value = '';
        }
    });
}

document.addEventListener('click', function (e) {
    const badge = e.target.closest('.remove-filter');
    if (badge) {
        const key = badge.getAttribute('data-key');
        const value = badge.getAttribute('data-value');
        removeFilterFromURL(key, value);
        renderFilterBadgesFromURL();
    }
});

document.addEventListener('DOMContentLoaded', () => {
    renderFilterBadgesFromURL();
});
